import request from "@/utils/http";

// 添加店员
export function addClerk(data) {
  return request.post("/user/add", data);
}

// 添加店员 新增
export function create(data) {
  return request.post("/merchant/accounts/create", data);
}

// 删除店员
export function dleteClerk(id) {
  return request.post(`/user/delete?userId=${id}`);
}

// 删除店员 新增
export function disable(id) {
  return request.post(`/merchant/accounts/disable/${id}`);
}

// 修改店员
export function editClerk(data) {
  return request.post("/user/update", data);
}

// 禁用店员 新增
export function Newdisable(accountId) {
  return request.post(`/merchant/accounts/disable/${accountId}`);
}

// 店员列表
export function clerkList() {
  return request.get("/user/list").then(res => res.result);
}

// 店员列表 新增
export function accounts() {
  return request.get("/merchant/accounts").then(res => res.result);
}
